<template>
  <a-modal
    width="40vw"
    v-model="visible"
    @cancel="closeModal"
    title="Rezerwacja"
  >
    <template #footer>
      <div class="footer">
        <span class="footer__time">
          Łącznie {{ reservation.reserved_slots.length }}h zajęć
        </span>
        <a-button @click="declineReservation" :disabled="loading">
          Odrzuć
        </a-button>
        <a-button
          @click="confirmReservation"
          type="primary"
          :disabled="loading"
        >
          Zatwierdź
        </a-button>
      </div>
    </template>

    <availability-label type="pending" class="header-label" />

    <a-skeleton v-if="loading" :active="true" />
    <div v-else>
      <icon-with-text icon="laptop">
        <strong>{{ reservation.course_details.name }}</strong>
      </icon-with-text>

      <icon-with-text icon="clock-circle">
        <div v-if="timespanMoments[0]">
          {{ timespanMoments[0].format('dddd') }},
          {{ timespanMoments[0].format('L') }}
          <strong>
            {{ timespanMoments[0].format('LT') }} –
            {{ timespanMoments[1].format('LT') }}
          </strong>
        </div>
        <div v-if="reservation.interval">
          {{ intervalLabel }} do {{ endMoment.format('L') }}
        </div>
      </icon-with-text>

      <icon-with-text icon="user">
        {{ reservation.course_details.lecturer.full_name }}
      </icon-with-text>

      <icon-with-text :component="StudentSvg">
        <span
          v-for="student in reservation.course_details.students"
          :key="student.id"
          class="student-name"
          >{{ student.full_name }}</span
        >
      </icon-with-text>
    </div>
  </a-modal>
</template>

<script>
import AvailabilityLabel from '@/components/common/AvailabilityLabel'
import IconWithText from '@/components/common/IconWithText'
import StudentSvg from '@/assets/student.svg'
import { Reservation } from '@/api'
import moment from 'moment'

export default {
  components: {
    AvailabilityLabel,
    IconWithText
  },
  data() {
    return {
      StudentSvg,
      visible: false,
      reservation: {
        reserved_slots: [],
        course_details: {
          lecturer: {},
          students: []
        }
      },
      loading: false
    }
  },
  methods: {
    confirmReservation() {
      this.loading = true
      Reservation.confirm(this.reservation.id)
        .then(() => {
          this.$notification.success({ message: 'Potwierdzono rezerwację.' })
          this.$emit('submit')
          this.closeModal()
        })
        .catch(() => {
          this.$message.error('Nie udało się potwierdzić rezerwacji.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    declineReservation() {
      this.loading = true
      Reservation.decline(this.reservation.id)
        .then(() => {
          this.$notification.success({ message: 'Odrzucono rezerwację.' })
          this.$emit('submit')
          this.closeModal()
        })
        .catch(() => {
          this.$message.error('Nie udało się odrzucić rezerwacji.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal(reservationId) {
      this.loading = true
      Reservation.get(reservationId)
        .then(res => {
          if (res.data.status !== 'pending') {
            this.visible = false
            this.$notification.error({
              message: 'Rezerwacja została już rozpatrzona.'
            })
            return
          }
          this.reservation = res.data
        })
        .finally(() => {
          this.loading = false
        })
      this.visible = true
    },
    closeModal() {
      this.visible = false
      this.reservation = {
        reserved_slots: [],
        course_details: {
          lecturer: {},
          students: []
        }
      }
    }
  },
  computed: {
    intervalLabel() {
      return this.getIntervalLabel(
        this.timespanMoments,
        this.reservation.interval
      )
    },
    endMoment() {
      return moment(this.reservation.interval_end)
    },
    timespanMoments() {
      const firstSlot = this.reservation.reserved_slots[0]
      return firstSlot
        ? [moment(firstSlot.timespan.lower), moment(firstSlot.timespan.upper)]
        : []
    }
  }
}
</script>

<style scoped lang="scss">
.header-label {
  position: absolute;
  top: -54px;
  left: 116px;
}

.footer {
  text-align: right;

  &__time {
    display: inline-block;
    font-size: 13px;
    margin-right: 16px;
  }
}

.students {
  list-style: none;
  margin: -8px 0 0;
  padding: 0;

  li:not(:last-child) {
    margin-bottom: 6px;
  }
}

.student-name {
  &:not(:last-child)::after {
    content: ', ';
  }
}
</style>
